import type { GamingLimitPeriod } from './gaming-limits.types';

export const GAMING_LIMIT_PERIODS = [
  'day',
  'week',
  'month',
] as const satisfies readonly GamingLimitPeriod[];

export const GAMING_LIMITS_PANEL_QUERY_KEY = 'panel';
export const GAMING_LIMITS_PANEL_QUERY_VALUE = 'gaming-limits';
export const GAMING_LIMITS_PROFILE_PATH = '/profile';
